/* eslint-disable no-console */
import { activate as activateOpenAIWidget, deactivate as deactivateOpenAIWidget, destroy as destroyOpenAIWidget } from '../openai/openaiWidget';
import { activate as activateAWSWidget, deactivate as deactivateAWSWidget, destroy as destroyAWSWidget } from '../aws/awsWidget';
import { subscribeLiveAgentChannel, unsubscribeLiveAgentChannel } from './liveAgentChannel';
import { fetchChatkitConversation, destroyChatkitConversation } from './apiRoutes';
import * as toggleHandler from './toggleHandler';
import * as endChatHandler from './endChatHandler';

const OPEN_AI_WORKFLOW_MODE = 'open_ai_workflow';
const AWS_CONNECT_MODE = 'aws_connect';

let widgetInitialized = false;
let containerDataset = null;

let mode = null;
let awsConnectContactId = null;
let pendingLiveAgentRequest = false;

export function setupWidgetButtons() {
  toggleHandler.setup();
  endChatHandler.setup();
}

export function cleanupWidgetButtons() {
  toggleHandler.cleanup();
  endChatHandler.cleanup();
}

function _container() {
  return document.getElementById('chatkit-widget-container');
}

function _setAgentName(name) {
  _container().querySelector('.agent-name').textContent = name;
}

async function _switchToOpenaiWidget(openAiChatkitThreadId = null) {
  deactivateAWSWidget();

  _setAgentName(containerDataset.openaiWidgetAgentName);
  subscribeLiveAgentChannel(containerDataset.personId);
  activateOpenAIWidget(openAiChatkitThreadId);

  widgetInitialized = true;
}

async function _switchToAwsWidget() {
  deactivateOpenAIWidget();
  unsubscribeLiveAgentChannel();

  _setAgentName(containerDataset.awsWidgetAgentName);
  activateAWSWidget(awsConnectContactId);

  widgetInitialized = true;
}

async function initializeWidget() {
  containerDataset = _container().dataset;

  const conversation = await fetchChatkitConversation();
  mode = conversation?.mode;
  awsConnectContactId = conversation?.aws_connect_contact_id;

  if (mode === OPEN_AI_WORKFLOW_MODE) {
    await _switchToOpenaiWidget(conversation?.open_ai_chatkit_thread_id);
  } else if (mode === AWS_CONNECT_MODE) {
    await _switchToAwsWidget();
  } else {
    throw new Error(`Unsupported chatkit mode: ${mode}`);
  }
}

document.addEventListener('chatkit.toggle.open', async () => {
  if (!widgetInitialized) await initializeWidget();
});

document.addEventListener('chatkit.end-chat', async () => {
  toggleHandler.close();
  await destroyChatkitConversation();
  await _switchToOpenaiWidget();
});

document.addEventListener('chatkit.aws.session-expired', async () => {
  await destroyChatkitConversation();
  await _switchToOpenaiWidget();
});

document.addEventListener('chatkit.aws.chat-ended', async () => {
  await destroyChatkitConversation();
});

document.addEventListener('chatkit.live-agent-request', (event) => {
  pendingLiveAgentRequest = true;
  awsConnectContactId = event.detail.aws_connect_contact_id;
});

document.addEventListener('chatkit.response.end', () => {
  if (!pendingLiveAgentRequest) return;

  pendingLiveAgentRequest = false;
  setTimeout(() => _switchToAwsWidget(), 3000);
});

export function destroyWidgets() {
  unsubscribeLiveAgentChannel();
  destroyOpenAIWidget();
  destroyAWSWidget();
  widgetInitialized = false;
}
